import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IRuteo } from './ruteo';
import * as myGlobals from '../global';
import { map } from 'rxjs/operators';
import { HttpClientSecured } from '../services/http-client-secured';

@Injectable({
  providedIn: 'root'
})
export class RuteosService {
  constructor(private http: HttpClientSecured) {}

  private _ruteosURL = myGlobals.baseApi + '/webadmin/v1/routing-rules';
  private _addRuteoURL = myGlobals.baseApi + '/webadmin/v1/routing-rule';
  private _merchantsURL = myGlobals.baseApi + '/webadmin/v1/routing-rule/merchants';
  private _issuersURL = myGlobals.baseApi + '/webadmin/v1/routing-rule/card-issuers';
  private _accountingNaturesURL = myGlobals.baseApi + '/webadmin/v1/routing-rule/accounting-natures';
  private _serviceInstancesURL = myGlobals.baseApi + '/webadmin/v1/routing-rule/service-instances';

  formData: IRuteo;

  getRuteos() {
    return this.http.get<any>(this._ruteosURL);
  }

  getRuteo(itemid: number): Observable<IRuteo | undefined> {
    return this.getRuteos().pipe(map((ruteos: IRuteo[]) => ruteos.find(p => p.id === itemid)));
  }

  getMerchants() {
    return this.http.get<any>(this._merchantsURL);
  }

  getIssuers() {
    return this.http.get<any>(this._issuersURL);
  }

  getAccountingNatures() {
    return this.http.get<any>(this._accountingNaturesURL);
  }

  getServiceInstances() {
    return this.http.get<any>(this._serviceInstancesURL);
  }

  addRuteo(bin) {
    return this.http.post<any>(this._addRuteoURL, bin);
  }
}
